module.exports = __webpack_public_path__ + "f97636287650542453c15779e453f704.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PlayfairDisplay-Regular.otf
// module id = 875
// module chunks = 0